import script from "./InterventionReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InterventionReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./InterventionReviewCard.vue?vue&type=style&index=0&id=1e6115e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6115e8"]])

export default __exports__